<template>
    <v-container>
        <v-layout>
            <v-flex>
                <img src="@/assets/kiosk_logo.png" width="200px">
            </v-flex>
            <v-flex>
                <v-flex headOrder xs6>
                    <h3>Sales Order</h3>
                </v-flex>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs11>
                <strong><font size="2">
                    No.(36),5th Floor(B), Zeyawaddy Street, Thantada Ward, Sanchuang TownShip,
                    Yangon Showroom : No.(23), Thanthumar Street, Yangonthit Ward Thingangyun Township, Yangon<br>
                    TEL: 097-78430074 Facebook: @KIOSKmyanmar
                </font></strong>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex text-xs-right>
                <strong>Order no: </strong>
                <input class="line" v-model="orderNo" size="10" disabled>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex text-xs-right>
                <strong>Date: </strong>
                <input class="line" v-model="orderDate" size="10" disabled>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <strong>Customer code: </strong>
                <input class="line" v-model="code" size="20" disabled>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <strong>Customer name: </strong>
                <input class="line" v-model="name" size="45" disabled>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <strong>Address: </strong>
            </v-flex>
            <v-flex xs12 class="line" ml-1>
                {{this.address}}
            </v-flex>
            <v-flex xs5></v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <strong>PO ref#: </strong>
                <input class="line" v-model="poRef" disabled>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <strong>Contact name: </strong>
                <input class="line" v-model="contact" size="30" disabled>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <strong>Tel: </strong>
                <input class="line" v-model="tel" size="30" disabled>
            </v-flex>
        </v-layout>
        <div v-for="(item,j) in table" :key="j" class="page-break-inside">
            <br>
            <table style="width:100%" v-if="item.length > 0">
                    <tr>
                        <th>No</th>
                        <th>Model</th>
                        <th>Description</th>
                        <th>Frame</th>
                        <th>Front</th>
                        <th style="text-align: right;">Quantity</th>
                        <th style="text-align: right;">Price</th>
                        <th style="text-align: right;">Amount</th>
                    </tr>
                    <tr v-for="item in item" :key="item.i">
                        <td style="text-align: center;">{{item.i}}</td>
                        <td>{{item.Code}}</td>
                        <td>{{item.NameMM}}</td>
                        <td style="text-align: center;">{{item.frame}}</td>
                        <td style="text-align: center;">{{item.front}}</td>
                        <td style="text-align: right;">{{item.num}}</td>
                        <td style="text-align: right;">{{item.PriceMM.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                        <td style="text-align: right;">{{(item.num * item.PriceMM).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                    </tr>
            </table>
        </div>
        <div class="page-break-inside">
            <v-layout>
                <v-flex xs6>
                    <v-flex>
                        <v-layout>
                            <v-flex>
                                <strong>Shipping Address: </strong>
                                <textarea rows="3" cols="75" class="border" v-model="shipAdd" disabled></textarea>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <strong>Shipping Date: </strong>
                                <input class="line" v-model="shipDate" size="10" disabled>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <strong>Remark: </strong>
                                <textarea rows="1" cols="75" class="border" v-model="remark" disabled></textarea>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-flex>
                <v-flex xs6>
                    <v-flex>
                        <v-layout>
                            <v-flex xs8 text-xs-right>
                                <strong>Total: </strong>
                            </v-flex>
                            <v-flex xs4>
                                <vue-numeric separator="," :precision="2" disabled :value="sumTotal" class="summary"></vue-numeric>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-flex>
            </v-layout>
            <br>
            <v-layout border v-for="(item,i) in countPayment" :key="item.i">
                <v-layout justify-center>
                    <v-flex xs3 mr-3>
                        <strong>Payment method {{i+1}}: </strong>
                        <input class="line" v-model="item.payMent" size="30" disabled>
                    </v-flex>
                    <v-flex xs4 ml-5>
                        <strong>Down payment {{i+1}}: </strong>
                        <vue-numeric separator="," :precision="2" disabled :value="item.down" class="down"></vue-numeric>
                    </v-flex>
                    <v-flex xs2 ml-3>
                        <strong>Payment date {{i+1}}: </strong>
                        <input class="line" v-model="item.date" size="15" disabled>
                    </v-flex>
                </v-layout>
            </v-layout>
            <br>
            <v-layout headOrder>
                <v-flex frame>
                    <strong>Approved and Received By</strong>
                    <v-layout pt-4 pb-4>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <strong>Manager</strong>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex>
                    <strong>Approved and Received By</strong>
                    <v-layout pt-4 pb-4>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <strong>Customer</strong>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </div>
    </v-container>
</template>

<script>
import {db} from '@/firebase'
import VueNumeric from 'vue-numeric'
export default {
    components: {
        VueNumeric
    },
    data(){
        return{
            orderNo: '',
            orderDate: '',
            code: '',
            name: '',
            address: '',
            poRef: '',
            contact: '',
            tel: '',

            detail: [],

            shipAdd: '',
            shipDate: '',
            remark: '',

            net: 0,
            countPayment: [],

            sumArr: [],
            table: [],
        }
    },
    computed:{

        // Calculate total
        sumTotal(){
            return this.sumArr.reduce((total,item) => total+(item.num * item.PriceMM),0)
        },
    },
    mounted(){
        db.collection("order").where("orderNo", "==", this.$route.query.orderNo).get()
        .then(snapshot=>{
            snapshot.forEach(Doc=>{
                let doc = Doc.data()
                this.orderNo = doc.orderNo
                this.orderDate = doc.orderDate.substr(0,10)
                this.code = doc.code
                this.name = doc.name
                this.address = doc.address
                this.poRef = doc.poRef
                this.contact = doc.contact
                this.tel = doc.tel
                this.sumArr = doc.detail
                this.table = ({ count: Math.ceil(doc.detail.length/15) })
                let i = 0
                let arr1 = []
                let arr2 = []
                doc.detail.forEach(rec=>{
                    if(i < 15){
                        arr1.push({ ...rec, i: i+1 })
                    }
                    if(i > 14 && i < 30){
                        arr2.push({ ...rec, i: i+1 })
                    }
                    i++
                })
                this.table = [arr1,arr2]
                this.shipAdd = doc.shipAdd
                this.shipDate = doc.shipDate
                this.remark = doc.remark
                this.net = doc.net
                this.countPayment = doc.countPayment
            })
            setTimeout(() => {
                window.print()
                window.close()
            }, 1)
        })
    }
}
</script>

<style scoped>
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.page {
    width: 210mm;
    min-height: 297mm;
    background: white;
}
@media print
{
    .page-break-inside{ page-break-inside: avoid; padding-top: 5mm; }
}
@page{
    margin: 0;
}
.collapse:nth-child(even){
    background-color: #dddddd;
}
.headOrder{
    border-top: 2px solid black;
    border-left: 2px solid black;
    border-right: 2px solid black;
    border-bottom: 2px solid black;
    text-align: center;
    /* width: 100%; */
}
.line{
    border-bottom: 1px solid black;
}

.table{
    border-top: 1px solid black;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
}
.tableDetail{
    /* border-top: 1px solid black; */
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
}
.numeric{
    text-align: right;
    width: 100%;
}
.summary{
    text-align: right;
    width: 100%;
    border-bottom: 1px solid black;
}
.border{
    border-top: 1px solid black;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    padding: 0.5%;
}
.down{
    text-align: right;
    width: 100%;
    border-bottom: 1px solid black;
}
.frame{
    border-right: 2px solid black;
    text-align: center;
}
</style>
